<!-- Start Breadcrumbs -->
<app-breadcrumbs
	title="Forecast"
	[breadcrumbItems]="breadCrumbItems"
></app-breadcrumbs>
<!-- End Breadcrumbs -->

<div class="row">
	<div class="col-lg-12">
		<div class="card" id="blackoutDaysList">
			<div class="card-header border-0">
				<div class="d-flex align-items-center">
					<h5 class="card-title mb-0 flex-grow-1">Forecast</h5>
				</div>
			</div>
			<div
				class="card-body border border-dashed border-end-0 border-start-0"
			>
				<div class="margin-top-2">
					<!-- Nav tabs -->
					<ul
						ngbNav
						#nav="ngbNav"
						[activeId]="1"
						class="nav nav-tabs nav-tabs-custom nav-success mb-3"
					>
						<li [ngbNavItem]="1">
							<a ngbNavLink>
								<i
									class="ri-calendar-2-fill me-1 align-bottom"
								></i
								>Leads
							</a>
							<ng-template ngbNavContent>
								<app-forecast-week></app-forecast-week>
							</ng-template>
						</li>

						<li [ngbNavItem]="2">
							<a ngbNavLink>
								<i
									class="ri-calendar-2-fill me-1 align-bottom"
								></i
								>Rescheduled
							</a>
							<ng-template ngbNavContent>
								<app-rescheduled-week></app-rescheduled-week>
							</ng-template>
						</li>

						<li [ngbNavItem]="3">
							<a ngbNavLink>
								<i
									class="ri-calendar-2-fill me-1 align-bottom"
								></i
								>Replacement
							</a>
							<ng-template ngbNavContent>
								<app-replacement-week></app-replacement-week>
							</ng-template>
						</li>

						<li [ngbNavItem]="4">
							<a ngbNavLink>
								<i
									class="ri-money-dollar-circle-fill me-1 align-bottom"
								></i
								>Income
							</a>
							<ng-template ngbNavContent>
								<app-income-week></app-income-week>
							</ng-template>
						</li>

						<!-- <li [ngbNavItem]="5">
							<a ngbNavLink>
							  <i class="ri-line-chart-line me-1 align-bottom"></i> Comparative Report
							</a>
							<ng-template ngbNavContent>
								<app-comparative-week></app-comparative-week>
							</ng-template>
						</li> -->
					</ul>

					<!-- Tab panes -->
					<div class="tab-content text-muted">
						<div [ngbNavOutlet]="nav"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
